<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="isLoading">
  <div
    style="
      position: fixed;
      z-index: 900;
      width: 100vw;
      height: 100vh;
      opacity: 80;
      top: 0;
      left: 0;
      background: #e8e8e880;
    "
  ></div>
  <mat-spinner class="spinner-center" style="z-index: 1000"></mat-spinner>
</div>

<!-- {{ learningCenterForm?.value | json }} -->
<div *ngIf="learningCenterForm">
  <div class="container">
    <div *ngIf="isEdit" class="row mb-4">
      <div class="ml-auto col-auto">
        <button
        id="delete-learning-center-button"
        style="border-radius: 4px"
          nzTooltipTitle="ลบศูนย์เรียนรู้นี้"
          nzTooltipPlacement="right"
          nz-tooltip
          class="d-flex justify-content-center align-items-center"
          nz-button
          nzSize="large"
          nzType="primary"
          nzDanger
          nz-popconfirm
          nzPopconfirmTitle="ข้อมูลจะถูกลบถาวร ท่านยืนยันหรือไม่"
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="deleteLearningCenter()"
          nzOkText="ลบ"
          nzCancelText="ย้อนกลับ"
          nzOkType="danger"
        >
          <span
            style="font-size: 26px"
            nz-icon
            nzType="delete"
            nzTheme="outline"
          ></span>
        </button>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <app-learning-center-upload-banner
          [learningCenterForm]="learningCenterForm"
          [isEdit]="isEdit"
        ></app-learning-center-upload-banner>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <app-learning-center-color-theme-picker
          *ngIf="(learningCenterColorTheme$ | async)?.length > 0"
          [learningCenterForm]="learningCenterForm"
          [learningCenterColorTheme]="learningCenterColorTheme$ | async"
        ></app-learning-center-color-theme-picker>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-lg-7 col-md-12 col-sm-12 mb-lg-0 mb-md-4 mb-sm-4">
        <app-learning-center-first-section-input
          [learningCenterForm]="learningCenterForm"
        ></app-learning-center-first-section-input>
      </div>
      <div class="col-lg-5 col-md-12 col-sm-12">
        <app-learning-center-profile-image-uploader
          [learningCenterForm]="learningCenterForm"
          [isEdit]="isEdit"
        ></app-learning-center-profile-image-uploader>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12">
        <app-learning-center-second-section-input
          [learningCenterForm]="learningCenterForm"
        ></app-learning-center-second-section-input>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12">
        <app-learning-center-third-section-input
          [learningCenterForm]="learningCenterForm"
          [isEdit]="isEdit"
        ></app-learning-center-third-section-input>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12">
        <app-learning-center-video-section-uploader
          [learningCenterForm]="learningCenterForm"
          [isEdit]="isEdit"
        ></app-learning-center-video-section-uploader>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12">
        <app-learning-center-research-section-input
          [learningCenterForm]="learningCenterForm"
        >
        </app-learning-center-research-section-input>
      </div>
    </div>

    <div class="row pb-4 d-flex justify-content-center">
      <div class="col-auto">
        <!-- <button nz-button nzType="primary" nzSize="large" style="background-color: #060E9F;" (click)="openModal()">
          Preview
        </button> -->
        <button id="preview-button" mat-flat-button style="background-color: #060E9F; color: white; font-size: 18px;" (click)="openModal()">
          Preview
        </button>
      </div>
    </div>
  </div>
</div>
